import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type SupportedLocale = 'ko' | 'ja' | 'zh';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['ko', 'ja', 'zh'];

// BCP 47 tags used by Intl APIs (date formatting, number formatting, etc.)
export const LOCALE_BCP47: Record<SupportedLocale, string> = {
  ko: 'ko-KR',
  ja: 'ja-JP',
  zh: 'zh-CN',
};

interface LocaleState {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'ko',
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'bhops-locale',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
